import apiFetch from '../apiFetch'

export default function (token, faqId) {
  return apiFetch({ endPoint: `Faq/${faqId}/Full`, method: 'GET', body: null, token: token })
}
